export default __webpack_public_path__ + "static/assets/e6e16daaf665399c8826497dfb888260.svg";